(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseDetailController', TrCaseDetailController);

    TrCaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrCase', 'User', 'CaseType', 'TrCaseImages', 'TrCaseRecordings','AlertService','$window','$localStorage','getCaseImage','Configs'];

    function TrCaseDetailController($scope, $rootScope, $stateParams, previousState, entity, TrCase, User, CaseType,TrCaseImages,TrCaseRecordings,AlertService, $window,$localStorage,getCaseImage,Configs) {
		var vm = this;
		
		/*if (entity.status) {
			entity.status = entity.status.replace("NEW", "PLANNING PHASE");
			entity.status = entity.status.replace("INPROGRESS", "ROLL-OUT PHASE");
			entity.status = entity.status.replace("RESOLVED", "OPERATION PHASE");
		}*/
        vm.trCase = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trCaseUpdate', function(event, result) {
            vm.trCase = result;
        });
		vm.showCaseAttachment = false

		Configs.get("CaseImage",function(response){
            if(response.length > 0){
				if(response[0].configValue == "True"){
					vm.showCaseAttachment = true
				}
			}
        })
		
        vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		};

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyecaseimages/"+vm.trCase.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrCaseImages.query(
                            {
                                caseId: vm.trCase.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.caseImages = data.filter(function(caseImages){
                                return caseImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getCaseImage.get(vm.trCase.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrCaseImages.query({
					caseId : vm.trCase.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.caseImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
		
        function decodeImage(img){
     	   return window.atob(img);
        }
         $scope.showCaseImages = function () {

                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) spinner.style.display = "block";

                $scope.mediaImagesIds = [];
                $scope.currentIndex = 0;

                $scope.caseName = "IncidentID_" + vm.trCase.id;

                TrCaseImages.query(
                    { caseId: vm.trCase.id },
                    function (data) {

                        angular.forEach(data, function (item, index) {
                            if (item.image) {
                                $scope.mediaImagesIds.push({
                                    base64: item.image,
                                    imageType: "IMAGE",
                                    imageName: "case_image_" + vm.trCase.id
                                });
                            }
                        });

                        if (!$scope.mediaImagesIds.length) {
                            alert("No images found for this case");
                            if (spinner) spinner.style.display = "none";
                            return;
                        }

                        if (spinner) spinner.style.display = "none";

                        $scope.loadMedia($scope.mediaImagesIds[0]);
                        $("#mediaCarouselModal").modal("show");
                    },
                    function (error) {
                        if (spinner) spinner.style.display = "none";
                        AlertService.error(error.data.message);
                    }
                );
            };
            $scope.loadMedia = function (media) {
                vm.showdownloadButton= true;
                var container = document.getElementById("carouselMediaContainer");
                if (!container) return;

                container.innerHTML = "";

                var img = document.createElement("img");
                img.src = "data:image/png;base64," + media.base64;
                img.style.maxWidth = "100%";
                img.style.maxHeight = "70vh";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");

                container.appendChild(img);
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform =
                        "translate(" + imgOffsetX + "px," + imgOffsetY + "px) scale(" + zoom + ")";
                }

                container.onwheel = function (e) {
                    e.preventDefault();
                    zoom += e.deltaY < 0 ? 0.1 : -0.1;
                    zoom = Math.min(Math.max(minZoom, zoom), maxZoom);
                    if (zoom === 1) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    }
                    applyTransform();
                };

                var isDragging = false, startX, startY, startOX, startOY;

                img.onmousedown = function (e) {
                    isDragging = true;
                    startX = e.clientX;
                    startY = e.clientY;
                    startOX = imgOffsetX;
                    startOY = imgOffsetY;
                };

                document.onmousemove = function (e) {
                    if (!isDragging) return;
                    imgOffsetX = startOX + (e.clientX - startX);
                    imgOffsetY = startOY + (e.clientY - startY);
                    applyTransform();
                };

                document.onmouseup = function () {
                    isDragging = false;
                };
            };
            $scope.nextMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex + 1) % $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.prevMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex - 1 + $scope.mediaImagesIds.length) %
                    $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.jumpToMedia = function (index) {
                $scope.currentIndex = index;
                $scope.loadMedia($scope.mediaImagesIds[index]);
            };
            $scope.downloadMedia = function () {
                var media = $scope.mediaImagesIds[$scope.currentIndex];
                if (!media) return;

                var link = document.createElement("a");
                link.href = "data:image/png;base64," + media.base64;
                link.download = media.imageName + ".png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
            vm.isMaximized = false;

            vm.toggleMaximize = function () {

                var modalDialog = document.getElementById("mediaModalDialog");
                var maxBtn = document.getElementById("maximizeBtn");
                var minBtn = document.getElementById("minimizeBtn");

                if (!vm.isMaximized) {
                    modalDialog.classList.add("modal-fullscreen-custom");

                    maxBtn.style.display = "none";
                    minBtn.style.display = "inline-block";
                    vm.isMaximized = true;
                } else {
                    modalDialog.classList.remove("modal-fullscreen-custom");
                    maxBtn.style.display = "inline-block";
                    minBtn.style.display = "none";
                    vm.isMaximized = false;
                }
            };
            vm.openPdfAttachments = function () {
                $("#loading-bar-spinner").show();
                getCaseImage.get(vm.trCase.id, function (res) {
                    $("#loading-bar-spinner").hide();
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    vm.attachments = res || [];
                    if (!vm.attachments.length) {
                        alert("No attachments available");
                        return;
                    }
                    $("#attachmentModal").modal("show");
                });
            };

       
    }
})();
